import { Injectable, signal } from '@angular/core';

export type OverlayName = 'beneficiary-plans' | 'plan-not-found' | 'essential-info' | 'clinical-staff' | 'health-plans' | 'subnet-info';

@Injectable({ providedIn: 'root' })
export class OverlayStackService {
  readonly stack = signal<OverlayName[]>([]);

  open(name: OverlayName) { this.stack.update((items) => [...items.filter((item) => item !== name), name]); }
  close(name: OverlayName) { this.stack.update((items) => items.filter((item) => item !== name)); }
  isOpen(name: OverlayName) { return this.stack().includes(name); }
  closeTop() {
    if (!this.stack().length) return false;
    this.stack.update((items) => items.slice(0, -1));
    return true;
  }
}
